/**
 * File search.js.
 */

//import Fuse from 'fuse.js'
const protocol = window.location.protocol
const hostname = window.location.hostname
const path = document.body.id
const cleanedPath = path.replace('-', '/')
const searchInput = document.querySelector('#search-input')
const searchTotal = document.querySelector('.search-total')
const suggestions = document.querySelector('.search-result')
const searchFilterItems = document.querySelectorAll('.search-filter-item')
const pdfsOnly = document.querySelector('#search-pdfs')
const productsOnly = document.querySelector('#search-products')
const catsOnly = document.querySelector('#search-categories')
const suggestionsContainer = document.querySelector('.search-result-container')
const cleanSearchInput = document.querySelector('#clean-search-input')
const closeSearchResult = document.querySelector('#close-search-result')

// const currentLang = document.documentElement.lang;
// const cleanLang = currentLang.replace('-', '_');
const currentLang = document.body.dataset.lang

// Check if dev
const devLocations = ['localhost', '.dev', '192.']
const isDev = devLocations.some((devLocation) => document.location.origin.includes(devLocation))

let endpoint

let fuse
if (isDev) {
    endpoint = `${lwGlobal.rootPath}search_result_${currentLang}.json`
} else {
    endpoint = `${lwGlobal.rootPath}search_result_${currentLang}.json`
}

fetch(endpoint)
    .then((blob) => blob.json())
    .then((datas) => {
        const search_list = [...datas].map((data) => {
            return data
        })
        const options = {
            // isCaseSensitive: false,
            includeScore: true,
            shouldSort: true,
            // includeMatches: true,
            // findAllMatches: false,
            minMatchCharLength: 2,
            // location: 0,
            threshold: 0.3,
            // distance: 100,
            useExtendedSearch: true,
            // ignoreLocation: false,
            // ignoreFieldNorm: false,
            keys: ['title', 'type', 'sku'],
        }
        fuse = new Fuse(search_list, options)
    })

function displayMatches(e) {
    let results
    if (pdfsOnly.checked) {
        results = fuse.search({ $and: [{ title: searchInput.value }, { type: '=attachment' }] })
    } else if (productsOnly.checked) {
        results = fuse.search({ $and: [{ title: searchInput.value }, { type: '=product' }] })
    } else if (catsOnly.checked) {
        results = fuse.search({ $and: [{ title: searchInput.value }, { type: '=category' }] })
    } else {
        results = fuse.search(searchInput.value)
    }

    if (!results) return

    const searchItems = results
        .map((searchItem) => {
            // let res = results.total;

            return /*html*/ `
			<li class="search-item">
				<a class="search-item-link" href="${searchItem.item.link}" ${
                searchItem.item.type === 'attachment' ? 'target="_blank"' : ''
            }>
					<div class="search-item-info">
						<div class="search-item-info-inner">
							${
                                searchItem.item.image
                                    ? `<img src="${searchItem.item.image}">`
                                    : `<span class="search-icon search-icon-${searchItem.item.type}"></span>`
                            }
							<span class="search-item-name">${searchItem.item.title}</span>
                        </div>
                        ${
                            searchItem.item.type === 'product'
                                ? `<div class="search-item-sku">Art nr: ${searchItem.item.sku}</div>`
                                : ''
                        }
					</div>
				</a>
				${
                    searchItem.item.type === 'attachment'
                        ? `<a class="attachment-download-link" href="${searchItem.item.link}" download>Ladda ner</a>`
                        : ''
                }
			</li>
		`
        })
        .join('')
    suggestions.innerHTML = searchItems
    // searchTotal.innerHTML = `Totalt: ${results.total}`;

    // Visa och dölj
    if (searchInput.value.length > 0) {
        cleanSearchInput.classList.add('show')
    } else {
        cleanSearchInput.classList.remove('show')
    }

    if (searchInput.value.length > 1) {
        suggestionsContainer.classList.add('show-suggestion')
        searchTotal.classList.add('show')
    } else {
        suggestionsContainer.classList.remove('show-suggestion')
        searchTotal.classList.remove('show')
    }
}

let searchWords
function setLatestSearch(e) {
    if (e.key === 'Enter' && searchInput.value.length > 0) {
        const searchContainer = {
            word: searchInput.value,
        }
        searchWords.push(searchContainer)
        localStorage.setItem('searchWord', JSON.stringify(searchWords))
    }
}

const latestSearchItems = document.querySelector('.latest-search-items')
function getLatestSearch() {
    if (localStorage.getItem('searchWord') !== null) {
        searchWords = JSON.parse(localStorage.getItem('searchWord'))

        const word = searchWords.slice(-5).map((searchWord) => {
            return `<div class="latest-word" data-id="${searchWord.word}">${searchWord.word}</div>`
        })
        latestSearchItems.innerHTML = word.join('')
    } else {
        searchWords = []
    }
}

const clearLatestSearch = document.querySelector('.clear-latest-search')

if (clearLatestSearch && localStorage.getItem('searchWord') !== null) {
    clearLatestSearch.addEventListener('click', () => {
        if (localStorage.getItem('searchWord')) {
            localStorage.removeItem('searchWord')
            latestSearchItems.innerHTML = ''
        }
    })
}

document.addEventListener('DOMContentLoaded', getLatestSearch)
searchInput && searchInput.addEventListener('keyup', setLatestSearch)

document.addEventListener('click', function (e) {
    if (e.target.matches('.latest-word')) {
        const searchPath = `${lwGlobal.homeUrl}/?s=${e.target.dataset.id}&post_type=product&search=on`
        window.location.assign(searchPath)
    }

    if (e.target.matches('.search-item-link')) {
        const name = e.target.querySelector('.search-item-name')
        const searchContainer = {
            word: name.textContent,
        }
        searchWords.push(searchContainer)
        localStorage.setItem('searchWord', JSON.stringify(searchWords))
    }

    if (e.target.matches('#search-overlay')) {
        closeSearch()
    }
})

function closeSearch() {
    searchInput.value = ''
    cleanSearchInput.classList.remove('show')
    closeSearchResult.classList.remove('show')
    document.body.classList.remove('search-active')
}
//module.exports = {
//    closeSearch
//};

const searchMegaItems = document.querySelectorAll('.mega-item')

searchInput.addEventListener('click', (e) => {
    document.body.classList.add('search-active')
    closeSearchResult.classList.add('show')
    searchMegaItems.forEach((megaItem) => megaItem.classList.remove('active'))
    if (searchInput.value != '') {
        displayMatches(e)
    }
})

cleanSearchInput.addEventListener('click', () => {
    searchInput.value = ''
    cleanSearchInput.classList.remove('show')
    searchInput.focus()
})

searchInput.addEventListener('keyup', (e) => {
    if (e.key === 'Escape') {
        closeSearch()
        searchInput.blur()
    }
})

closeSearchResult.addEventListener('click', closeSearch)
// searchInput.addEventListener('change', displayMatches);
searchFilterItems.forEach((filterItem) => filterItem.addEventListener('change', displayMatches))
searchInput.addEventListener('keyup', displayMatches)
